import React from 'react';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';

const DateItem = ({ data, label }) => {
  return (
    <DateItemContainer>
      <Typography component='span' variant='body2' color='textPrimary'>
        <strong>{label}:</strong>
      </Typography>
      {data || 'Sin datos'}
    </DateItemContainer>
  );
};

const DateItemContainer = styled.div`
  padding: 0 2em 0 0;
  text-align: justify;
`;

export default DateItem;
